// @flow

import { get, isEmpty, partial } from 'lodash';

import type { EditorService } from './types';

const isPathTrue = (path, service) => Boolean(get(service, path, null));
const isAnyPathTrue = (paths, service) =>
  paths.some(path => isPathTrue(path, service));

// The multiple keys here represent legacy data structure and the updated
// GraphQL equivalent
export const isBeta = partial(isAnyPathTrue, ['beta', 'isBeta']);
export const isBuiltIn = partial(isAnyPathTrue, ['builtIn', 'isBuiltIn']);
export const isDeprecated = partial(isAnyPathTrue, [
  'deprecated',
  'isDeprecated',
]);
export const isFeatured = partial(isAnyPathTrue, ['featured', 'isFeatured']);
export const isHidden = partial(isAnyPathTrue, ['hidden', 'isHidden']);
export const isPremium = partial(isAnyPathTrue, ['premium', 'isPremium']);
export const isInvite = partial(isAnyPathTrue, ['invite_app', 'isInvite']);
export const isPublic = partial(isAnyPathTrue, ['public', 'isPublic']);
export const isOauth = (service: EditorService) => {
  const authType = get(service, 'authType', null);
  const oauthService = get(service, ['meta', 'oauth'], false);
  return authType === 'oauth' || oauthService;
};
export const hasUpfrontFields = (service: EditorService) => {
  return Boolean(service.hasUpfrontFields) || !isEmpty(service.upfront_fields);
};
